/** Shared frontend constants organized in a plain object. */
export const FrontendConstants = {
  ReferenceWidthLandscape: 1536, // Design reference width in pixels.
  ReferenceHeightLandscape: 730, // Design reference height in pixels.
  ReferenceWidthPortrait: 730, // Design reference width in pixels.
  ReferenceHeightPortrait: 1536, // Design reference height in pixels.
  MinWidthLandscape: 480, // Minimum canvas width in landscape.
  MinHeightLandscape: 160, // Minimum canvas height in landscape.
  MinWidthPortrait: 160, // Minimum canvas width in portrait.
  MinHeightPortrait: 480, // Minimum canvas height in portrait.

  // Root font size scaling.
  ReferenceFontSize: 16, // Base font size in pixels at reference resolution.
  MinFontSize: 6, // Minimum font size in pixels.
  MaxFontSize: 18, // Maximum font size in pixels.

  // Delay (ms) after `orientationchange` before re-querying window dimensions. Android Chrome fires `resize` BEFORE the viewport finishes updating during rotation
  // (especially landscape to portrait): `innerHeight` updates first while `innerWidth` is still stale-landscape, causing `GetLayout` to compute a portrait scaler against
  // landscape width and render ~10-15% oversized. A deferred recompute after the viewport settles fixes this. iOS Safari only fires `resize` once the viewport is stable,
  // so this is effectively an Android workaround.
  OrientationStabilizeMs: 200,

  // HTTP method strings.
  MethodGet: 'GET',
  MethodPost: 'POST',
  MethodPut: 'PUT',
  MethodDelete: 'DELETE',

  // HTTP header names and values.
  HeaderContentType: 'Content-Type',
  ContentTypeJson: 'application/json',

  // Authorization header scheme.
  BearerScheme: 'Bearer ',

  // Asset/preload link attributes.
  RelPreload: 'preload',

  // Fetch cache options.
  CacheNoStore: 'no-store',

  // Manifest filenames.
  LatestManifestFile: 'latest.json',

  // Email address separator for deriving usernames.
  EmailSeparator: '@',

  // Authorization HTTP header name.
  HeaderAuthorization: 'Authorization',

  // Login attempt lockout: redirect to /errors/403.html after this many consecutive invalid-credentials failures.
  MaxFailedLoginAttempts: 3,

  // Path of the static 403 page used by the access-control redirects (Lobby env gate, Portal whitelist gate, login lockout).
  // Relative (no leading slash) so callers prepend `import.meta.env.BASE_URL` — resolves to `/errors/403.html` in dev and
  // `/web/apps/<name>/errors/403.html` in prod where the consolidated assets container serves each SPA under its own subpath.
  AccessDeniedRedirectPath: 'errors/403.html',
  AccessDeniedIPParam: 'ip',

  // HTTP status code surfaced by backend authorization denials (NestJS ForbiddenException). Clients should treat 403 as a valid runtime outcome,
  // not a fault: log at Debug and render an "Unauthorized" message rather than the generic failure copy.
  HTTPStatusForbidden: 403,

  // HTTP status code for an unauthenticated request (no/invalid session). Treated as an expected runtime outcome (visitor, expired session), not a fault.
  HTTPStatusUnauthorized: 401,

  // HTTP status code for "not found" — used by clients to map an absent resource to a null result rather than throwing.
  HTTPStatusNotFound: 404,

  // Error.code tag set by client methods when the backend returns 403, so callers can distinguish authorization denials from other failures.
  ErrorCodeUnauthorized: 'Unauthorized'
} as const;
